import React from 'react';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectChatMessageByKey,
    selectFailedMessageByKey,
} from 'flow/selectors/chat-message-selectors';
import { ChatMessageKey, ChatSessionKey } from 'flow/types/EntityKeys';
import ChatMessage from 'flow/pages/messages/ChatMessage';

interface Props {
    chatSessionKey: ChatSessionKey;
    chatMessageKey: ChatMessageKey;
    showAvatar: boolean;
    /** Dark variant, see MessagesPage. */
    videoDark?: boolean;
}

const ChatMessageRow = ({
    chatSessionKey,
    chatMessageKey,
    showAvatar,
    videoDark = false,
}: Props) => {
    const message = useAppSelector(
        (state) =>
            selectChatMessageByKey(state, chatSessionKey, chatMessageKey) ??
            selectFailedMessageByKey(state, chatSessionKey, chatMessageKey),
    );

    if (!message) return null;

    return (
        <ChatMessage
            sessionKey={chatSessionKey}
            message={message}
            showAvatar={showAvatar}
            videoDark={videoDark}
        />
    );
};

export default React.memo(ChatMessageRow);
